// JS for LPv2 Main Product Gallery block
export function initGalleryBlock() {
  // Only run if gallery exists
  const galleryEl = document.querySelector('.main-swiper');
  if (!galleryEl) return;

  let mainSwiper;

  function loadSlideMedia(slideIndex) {
    if (!mainSwiper || !mainSwiper.slides) return;
    const slide = mainSwiper.slides[slideIndex];
    if (!slide) return;
    // Handle images
    const images = slide.querySelectorAll('img[data-src]');
    images.forEach(img => {
      if (!img.dataset.loaded) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
        img.classList.add('loaded');
        img.dataset.loaded = 'true';
      }
    });
    // Handle videos (native video elements)
    const videos = slide.querySelectorAll('video[data-src]');
    videos.forEach(video => {
      if (!video.dataset.loaded) {
        const source = video.querySelector('source');
        if (source && source.dataset.src) {
          source.src = source.dataset.src;
          video.load();
        }
        video.dataset.loaded = 'true';
      }
    });
    // Handle iframes (external videos like YouTube/Vimeo)
    const iframes = slide.querySelectorAll('iframe[data-src]');
    iframes.forEach(iframe => {
      if (!iframe.dataset.loaded) {
        iframe.src = iframe.dataset.src;
        iframe.dataset.loaded = 'true';
      }
    });
    // Handle video containers with poster images
    const videoContainers = slide.querySelectorAll('.gallery-video-container');
    videoContainers.forEach(container => {
      if (!container.dataset.loaded) {
        // Load the poster image if it has data-src
        const posterImg = container.querySelector('.gallery-video-poster img[data-src]');
        if (posterImg && !posterImg.dataset.loaded) {
          posterImg.src = posterImg.dataset.src;
          if (posterImg.dataset.srcset) {
            posterImg.srcset = posterImg.dataset.srcset;
          }
          posterImg.classList.add('loaded');
          posterImg.dataset.loaded = 'true';
        }
        // Load the video/iframe if it has data-src
        const video = container.querySelector('.gallery-video video[data-src], .gallery-video iframe[data-src]');
        if (video && !video.dataset.loaded) {
          if (video.tagName === 'VIDEO') {
            const source = video.querySelector('source');
            if (source && source.dataset.src) {
              source.src = source.dataset.src;
              video.load();
            }
          } else if (video.tagName === 'IFRAME') {
            video.src = video.dataset.src;
          }
          video.dataset.loaded = 'true';
        }
        container.dataset.loaded = 'true';
      }
    });
  }


  // Video play button handler
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.video-play-button');
    if (!btn) return;
    const videoContainer = btn.closest('.gallery-video-container');
    if (!videoContainer) return;
    const poster = videoContainer.querySelector('.gallery-video-poster');
    const video = videoContainer.querySelector('.gallery-video');
    const videoElement = video ? video.querySelector('video, iframe') : null;
    if (poster) poster.style.display = 'none';
    if (video) video.style.display = 'block';
    if (videoElement) {
      if (videoElement.tagName === 'IFRAME' && !videoElement.src) {
        videoElement.src = videoElement.dataset.src;
      } else if (videoElement.tagName === 'VIDEO' && !videoElement.querySelector('source').src) {
        videoElement.querySelector('source').src = videoElement.querySelector('source').dataset.src;
        videoElement.load();
        videoElement.play();
      }
    }
  });

  // Variant sync logic (already present)
  document.addEventListener('lpv2-state-changed', function(e) {
    if (!window.mainSwiper) return;
    
    const state = e.detail;
    const variantId = state.selectedVariantId;
    
    if (!variantId) return;
    
    const slides = document.querySelectorAll('.main-swiper-slide');
    
    let targetIndex = -1;
    slides.forEach((slide, idx) => {
      const variantIds = (slide.getAttribute('data-variant-id') || '').split(',');
      if (variantIds.includes(String(variantId))) {
        targetIndex = idx;
      }
    });
	
    if (targetIndex >= 0) {
      window.mainSwiper.slideTo(targetIndex, 300);
    }
  });
} 